module.exports = __webpack_public_path__ + "img/super.ab1e86d4.svg";